module.exports = __webpack_public_path__ + "img/visa.9bcb4057.svg";